import { render, staticRenderFns } from "./CampaignMassiveCreation.vue?vue&type=template&id=821de0d2&scoped=true&"
import script from "./CampaignMassiveCreation.vue?vue&type=script&lang=js&"
export * from "./CampaignMassiveCreation.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMassiveCreation.vue?vue&type=style&index=0&id=821de0d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821de0d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VChip,VDialog,VFileInput,VSheet})
